import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Calculator, ChevronDown, ChevronRight, Database } from "lucide-react";
import { api } from "@/lib/api";

const STATUS = {
    manual: ["Manual", "border-slate-600 text-slate-300"],
    partly_data: ["Partly data-driven", "border-sky-400/40 text-sky-300"],
    mostly_data: ["Mostly data-driven", "border-violet-400/40 text-violet-300"],
};

/** QA Radar aside — how data-driven every client's lead values are + global CTA coverage. */
export function ValueHealthCard() {
    const [open, setOpen] = useState(true);
    const [h, setH] = useState(null);
    useEffect(() => { api.get("/v1/ripeness/value/health").then((r) => setH(r.data)).catch(() => setH(null)); }, []);
    return (
        <div className="rounded-lg border border-slate-700/60 bg-slate-900/40 p-4" data-testid="value-health-panel">
            <button onClick={() => setOpen(!open)} className="w-full flex items-center justify-between text-xs uppercase tracking-wider text-slate-400 mb-2" data-testid="value-health-toggle">
                <span className="inline-flex items-center gap-1.5"><Calculator className="w-3.5 h-3.5" /> Value model</span>
                {open ? <ChevronDown className="w-3.5 h-3.5" /> : <ChevronRight className="w-3.5 h-3.5" />}
            </button>
            {open ? (!h ? <div className="text-xs text-slate-500 italic">Loading…</div> : (
                <div className="text-xs space-y-2">
                    <div className="text-slate-400" data-testid="value-health-global">
                        <Database className="w-3 h-3 inline mr-1 text-violet-300" /> Global: <b className="text-slate-200">{h.global.budgets}</b> CTA budgets · <b className="text-slate-200">{h.global.data_driven_rows}</b> data-driven rows (k = {h.global.k ?? 5}) · v{h.global.version}
                    </div>
                    <div className="grid grid-cols-3 gap-2" data-testid="value-health-counts">
                        {Object.entries(STATUS).map(([k, [label, tone]]) => (
                            <div key={k} className={`rounded border px-2 py-1 ${tone}`} data-testid={`value-health-count-${k}`}>
                                <div className="text-lg font-semibold leading-tight">{h.counts[k]}</div>
                                <div className="text-[10px] uppercase tracking-wider opacity-80">{label}</div>
                            </div>
                        ))}
                    </div>
                    {h.clients.length ? (
                        <ul className="space-y-0.5 max-h-40 overflow-auto" data-testid="value-health-clients">
                            {h.clients.map((c) => (
                                <li key={c.client_id} className="flex items-center gap-2" data-testid={`value-health-client-${c.client_id}`}>
                                    <Link to={`/qa/value-assumptions?client_id=${encodeURIComponent(c.client_id)}`} className="flex-1 truncate text-sky-300 hover:underline">{c.client_id}</Link>
                                    <span className="text-slate-500">v{c.version}{c.locks ? ` · ${c.locks} lock${c.locks > 1 ? "s" : ""}` : ""}{c.has_weights ? " · weights" : ""}{c.location?.length ? ` · ${c.location.join("/")}` : ""}</span>
                                    <span className={`rounded border px-1 text-[9px] uppercase ${STATUS[c.status][1]}`}>{STATUS[c.status][0]}</span>
                                </li>
                            ))}
                        </ul>
                    ) : <div className="text-slate-500 italic" data-testid="value-health-empty">No client has touched its value assumptions yet — all inherit the global defaults.</div>}
                    <Link to="/qa/value-assumptions" className="inline-block text-emerald-300 hover:underline" data-testid="value-health-link">Open value assumptions →</Link>
                </div>
            )) : null}
        </div>
    );
}
